import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import React from "react";

import "./styles.css";

/**
 * @function OneTimePaymentPage
 * @return {React.Component}
 * @exported true
 * @description The main component for OneTimePaymentPage
 */
export default function OneTimePaymentPage(props) {
  return (
    <MainContentContainer className="one-time-payment-page" header={<MainContentHeader text="One Time Payment" />}>
      { props.view}
    </MainContentContainer>
  )
}
